var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.3514e-05 21.9393C4.77182 19.6833 7.15771 17.0326 7.15771 13.987C5.12381 13.7614 3.44194 12.9624 2.11208 11.59C0.782218 10.2176 0.1173 8.62907 0.1173 6.82429C0.1173 4.90671 0.762663 3.28995 2.05341 1.97397C3.34416 0.657979 4.96735 -2.351e-06 6.92304 -2.18003e-06C9.1134 -1.98854e-06 11.0104 0.855375 12.614 2.56616C14.2177 4.27694 15.0195 6.35429 15.0195 8.79826C15.0195 16.1302 10.7562 21.864 2.22942 26L-4.3514e-05 21.9393ZM16.8401 21.9393C21.651 19.6833 24.0565 17.0326 24.0565 13.987C21.9835 13.7614 20.2821 12.9624 18.9522 11.59C17.6223 10.2176 16.9574 8.62907 16.9574 6.82429C16.9574 4.90671 17.6125 3.28995 18.9229 1.97397C20.2332 0.657981 21.8661 -8.73659e-07 23.8218 -7.02688e-07C26.0122 -5.112e-07 27.8994 0.855377 29.4835 2.56616C31.0676 4.27694 31.8596 6.35429 31.8596 8.79827C31.8596 16.1302 27.6159 21.864 19.1282 26L16.8401 21.9393Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftQuote);
export default __webpack_public_path__ + "static/media/leftQuote.8ce79db4dc138f570b7c05ad1f2250f5.svg";
export { ForwardRef as ReactComponent };